import { lazy } from 'react';
import retry from '../../utils/webpack/chunkRetry';
const ModuleLoaderLazy = lazy(()=>retry(()=>import(/* webpackChunkName: "discord" */ './ModuleLoader')));
export default ModuleLoaderLazy;

//# sourceMappingURL=ModuleLoaderLazy.js.map